import { CancelToken } from "axios";
import { authAxios as axios } from "shared-auth";
import { IJobSettings } from "shared/models/settings";

import config from "config/global";

class JobSettingsService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(cancellationToken?: CancelToken): Promise<IJobSettings> {
    const response = await axios(this.url, {
      cancelToken: cancellationToken,
    });

    return response.data;
  }

  public async update(
    data: IJobSettings,
    cancellationToken?: CancelToken
  ): Promise<IJobSettings> {
    const response = await axios(this.url, {
      method: "put",
      data,

      cancelToken: cancellationToken,
    });

    return response.data;
  }
}

export const jobSettingsApiUrl = `${config.linkboardApiUrl}/settings`;

export default new JobSettingsService({
  url: jobSettingsApiUrl,
});
